export default {
  AppName: 'بادپا',
  AppTagline: 'پیشخوان مدیریت'
}
